<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content=" County Outdoor Advertisement Management System" name="description"/>
      <meta content=" County" name="author"/>
      <!-- App favicon -->
      <link href="assets/images/favicon.png" rel="shortcut icon">
      <!-- Leaflet CSS for Maps -->
      <link rel="stylesheet" href="https://unpkg.com/leaflet@1.9.4/dist/leaflet.css" />
      <!-- Leaflet JS -->
      <!-- DataTables -->
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap select styling -->
      <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css" rel="stylesheet">
      <!-- Icon Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <!-- Custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
    </head>

    <body data-sidebar="dark">
    <!-- Begin page -->
    <div id="layout-wrapper">
      <NavigationBar/>

      <!-- Start right Content here -->
      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">

            <!-- Page title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18"> COUNTY OUTDOOR ADVERTISEMENT REGISTRY</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a @click="goTo('dashboard')">Dashboards</a></li>
                      <li class="breadcrumb-item active">OUTDOOR ADVERTISING</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- Alert Messages -->
            <div class="row" v-if="alert.success || alert.failed || alert.info">
              <div class="col-12">
                <div v-if="alert.success" class="alert alert-success alert-dismissible fade show" role="alert">
                  <strong>Success!</strong> {{ message }}
                  <button type="button" class="btn-close" @click="alert.success = false"></button>
                </div>
                <div v-if="alert.failed" class="alert alert-danger alert-dismissible fade show" role="alert">
                  <strong>Error!</strong> {{ message }}
                  <button type="button" class="btn-close" @click="alert.failed = false"></button>
                </div>
                <div v-if="alert.info" class="alert alert-info alert-dismissible fade show" role="alert">
                  <strong>Info!</strong> {{ message }}
                  <button type="button" class="btn-close" @click="alert.info = false"></button>
                </div>
              </div>
            </div>

            <!-- Statistics Cards -->
            <div class="row mb-4">
              <div class="col-xl-2 col-md-4">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-1 overflow-hidden">
                        <p class="text-truncate font-size-14 mb-2">Total Advertisements</p>
                        <h4 class="mb-0">{{ formatNumber(statistics.totalAds) }}</h4>
                      </div>
                      <div class="text-primary ms-auto">
                        <i class="ri-advertisement-line font-size-24"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-2 col-md-4">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-1 overflow-hidden">
                        <p class="text-truncate font-size-14 mb-2">Active Campaigns</p>
                        <h4 class="mb-0 text-success">{{ formatNumber(statistics.activeAds) }}</h4>
                      </div>
                      <div class="text-success ms-auto">
                        <i class="ri-play-circle-line font-size-24"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-2 col-md-4">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-1 overflow-hidden">
                        <p class="text-truncate font-size-14 mb-2">Expired</p>
                        <h4 class="mb-0 text-danger">{{ formatNumber(statistics.expiredAds) }}</h4>
                      </div>
                      <div class="text-danger ms-auto">
                        <i class="ri-time-line font-size-24"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-2 col-md-4">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-1 overflow-hidden">
                        <p class="text-truncate font-size-14 mb-2">Pending Approval</p>
                        <h4 class="mb-0 text-warning">{{ formatNumber(statistics.pendingAds) }}</h4>
                      </div>
                      <div class="text-warning ms-auto">
                        <i class="ri-hourglass-line font-size-24"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-2 col-md-4">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-1 overflow-hidden">
                        <p class="text-truncate font-size-14 mb-2">Monthly Revenue</p>
                        <h4 class="mb-0">{{ formatPrice(statistics.monthlyRevenue) }}</h4>
                      </div>
                      <div class="text-success ms-auto">
                        <i class="ri-money-dollar-circle-line font-size-24"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-2 col-md-4">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-1 overflow-hidden">
                        <p class="text-truncate font-size-14 mb-2">Penalties Collected</p>
                        <h4 class="mb-0">{{ formatPrice(statistics.penalties) }}</h4>
                      </div>
                      <div class="text-danger ms-auto">
                        <i class="ri-alert-line font-size-24"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="row mb-4">
              <div class="col-12">
                <div class="d-flex gap-2 flex-wrap">
                  <button @click="openAdvertModal()"
                          class="btn btn-primary">
                    <i class="mdi mdi-plus-circle-outline me-1"></i>
                    Register Advertisement
                  </button>
                  <button @click="openBulkUpload"
                          class="btn btn-info">
                    <i class="mdi mdi-cloud-upload-outline me-1"></i>
                    Bulk Upload
                  </button>
                  <button @click="generateInvoices"
                          class="btn btn-success">
                    <i class="mdi mdi-receipt me-1"></i>
                    Generate Invoices
                  </button>
                  <button @click="generatePenalties"
                          class="btn btn-warning">
                    <i class="mdi mdi-alert-octagon me-1"></i>
                    Generate Penalties
                  </button>
                  <button @click="generateReports"
                          class="btn btn-secondary">
                    <i class="mdi mdi-file-chart me-1"></i>
                    Advertisement Reports
                  </button>
                  <button @click="toggleViewMode"
                          :class="viewMode === 'map' ? 'btn btn-dark' : 'btn btn-outline-dark'">
                    <i class="mdi mdi-map me-1"></i>
                    {{ viewMode === 'map' ? 'Hide Map' : 'Show Map View' }}
                  </button>
                </div>
              </div>
            </div>

            <!-- Main Content -->
            <div class="row">
              <!-- Map View -->
              <div v-if="viewMode === 'map'" class="col-12 mb-4">
                <div class="card">
                  <div class="card-header bg-white border-bottom">
                    <h5 class="card-title mb-0">
                      <i class="mdi mdi-map-marker-multiple me-2"></i>
                      Advertisement Locations Map
                    </h5>
                    <div class="d-flex gap-2 mt-2">
                      <div class="legend-item">
                        <span class="badge bg-success">Active</span>
                      </div>
                      <div class="legend-item">
                        <span class="badge bg-danger">Expired</span>
                      </div>
                      <div class="legend-item">
                        <span class="badge bg-warning">Pending</span>
                      </div>
                    </div>
                  </div>
                  <div class="card-body p-0">
                    <div id="advertisement-map" ref="mapContainer" style="height: 500px; width: 100%;"></div>
                  </div>
                  <!-- Map Legend and Quick Actions -->
                  <div class="card-footer bg-white">
                    <div class="row align-items-center">
                      <div class="col-md-8">
                        <div class="d-flex gap-3 align-items-center">
                          <span class="fw-semibold">Map Legend:</span>
                          <div class="d-flex align-items-center">
                            <div class="marker-legend active me-2"></div>
                            <small>Active ({{ statistics.activeAds }})</small>
                          </div>
                          <div class="d-flex align-items-center">
                            <div class="marker-legend expired me-2"></div>
                            <small>Expired ({{ statistics.expiredAds }})</small>
                          </div>
                          <div class="d-flex align-items-center">
                            <div class="marker-legend pending me-2"></div>
                            <small>Pending ({{ statistics.pendingAds }})</small>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 text-end">
                        <button @click="centerMap" class="btn btn-sm btn-outline-primary me-2">
                          <i class="mdi mdi-crosshairs-gps me-1"></i>Center Map
                        </button>
                        <button @click="toggleMarkers" class="btn btn-sm btn-outline-secondary">
                          <i class="mdi mdi-eye me-1"></i>{{ showAllMarkers ? 'Hide' : 'Show' }} All
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Table View -->
              <div class="col-12">
                <div class="card">
                  <!-- Header with Tabs -->
                  <div class="card-header bg-white border-bottom">
                    <ul class="nav nav-tabs card-header-tabs" role="tablist">
                      <li class="nav-item">
                        <a class="nav-link active" data-bs-toggle="tab" href="#all-ads" role="tab">
                          <i class="mdi mdi-view-grid me-1"></i>
                          All Advertisements ({{ filteredAdvertisements.length }})
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="tab" href="#billboards" role="tab">
                          <i class="mdi mdi-billboard me-1"></i>
                          Billboards ({{ getAdCount('BILLBOARD') }})
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="tab" href="#signages" role="tab">
                          <i class="mdi mdi-sign-caution me-1"></i>
                          Signages ({{ getAdCount('SIGNAGE') }})
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="tab" href="#mobile-ads" role="tab">
                          <i class="mdi mdi-truck me-1"></i>
                          Mobile Ads ({{ getAdCount('MOBILE') }})
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="tab" href="#posters" role="tab">
                          <i class="mdi mdi-file-image me-1"></i>
                          Posters/Flyers ({{ getAdCount('POSTER') }})
                        </a>
                      </li>
                    </ul>
                  </div>

                  <!-- Filters -->
                  <div class="card-header bg-white border-bottom">
                    <div class="row g-3 align-items-center">
                      <!-- Type Filter -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">Type:</label>
                        <select v-model="filters.type" @change="filterAdvertisements" class="form-select">
                          <option value="">All Types</option>
                          <option value="BILLBOARD">Billboard</option>
                          <option value="SIGNAGE">Signage</option>
                          <option value="MOBILE">Mobile Advertisement</option>
                          <option value="POSTER">Poster/Flyer</option>
                          <option value="BANNER">Banner</option>
                        </select>
                      </div>

                      <!-- Status Filter -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">Status:</label>
                        <select v-model="filters.status" @change="filterAdvertisements" class="form-select">
                          <option value="">All Status</option>
                          <option value="ACTIVE">Active</option>
                          <option value="EXPIRED">Expired</option>
                          <option value="PENDING">Pending Approval</option>
                          <option value="SUSPENDED">Suspended</option>
                        </select>
                      </div>

                      <!-- Sub County Filter -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">Sub County:</label>
                        <select v-model="filters.subCounty" @change="filterAdvertisements" class="form-select">
                          <option value="">All Sub Counties</option>
                          <option v-for="subCounty in subCounties" :key="subCounty" :value="subCounty">
                            {{ subCounty }}
                          </option>
                        </select>
                      </div>

                      <!-- Ward Filter -->
                      <div class="col-md-2">
                        <label class="form-label mb-1">Ward:</label>
                        <select v-model="filters.ward" @change="filterAdvertisements" class="form-select">
                          <option value="">All Wards</option>
                          <option v-for="ward in wards" :key="ward" :value="ward">
                            {{ ward }}
                          </option>
                        </select>
                      </div>

                      <!-- Search -->
                      <div class="col-md-4">
                        <label class="form-label mb-1">Search:</label>
                        <div class="position-relative">
                          <input v-model="search" type="text" class="form-control"
                                 placeholder="Search by ad ID, name, client...">
                          <i class="bx bx-search-alt position-absolute top-50 end-0 translate-middle-y me-3"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Tab Content -->
                  <div class="tab-content">
                    <!-- All Advertisements Tab -->
                    <div class="tab-pane fade show active" id="all-ads" role="tabpanel">
                      <div class="card-body p-0">
                        <div class="table-responsive">
                          <table class="table table-hover mb-0">
                            <thead class="table-dark">
                            <tr>
                              <th class="text-nowrap">NO.</th>
                              <th class="text-nowrap">Advertisement Preview</th>
                              <th class="text-nowrap">Advertisement ID</th>
                              <th class="text-nowrap">Type & Size</th>
                              <th class="text-nowrap">Location</th>
                              <th class="text-nowrap">Client Details</th>
                              <th class="text-nowrap">Duration & Payment</th>
                              <th class="text-nowrap">Status</th>
                              <th class="text-nowrap">Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(ad, index) in paginatedAdvertisements" :key="ad.id">
                              <td class="text-nowrap">{{ (currentPage - 1) * pageSize + index + 1 }}</td>
                              <td style="min-width: 300px;">
                                <div class="d-flex align-items-center">
                                  <div class="position-relative me-3">
                                    <img :src="ad.image || ad.imagePreview || 'https://via.placeholder.com/80x60'"
                                         class="rounded"
                                         style="width: 80px; height: 60px; object-fit: cover;"
                                         :alt="ad.name">
                                    <div class="position-absolute top-0 start-0 p-1">
                                      <span class="badge bg-dark bg-opacity-75 text-white" style="font-size: 0.6rem;">
                                        {{ ad.type }}
                                      </span>
                                    </div>
                                  </div>
                                  <div>
                                    <strong>{{ ad.name }}</strong>
                                    <small class="text-muted d-block">{{ ad.description }}</small>
                                    <small class="text-muted d-block">
                                      <i class="mdi mdi-calendar me-1"></i>
                                      {{ ad.startDate }} - {{ ad.endDate }}
                                    </small>
                                  </div>
                                </div>
                              </td>
                              <td class="text-nowrap">
                                <span class="fw-bold">{{ ad.advertisementId }}</span>
                              </td>
                              <td class="text-nowrap">
                                <span class="badge" :class="getTypeClass(ad.type)">
                                  {{ formatAdType(ad.type) }}
                                </span>
                                <small class="text-muted d-block">{{ ad.size }}</small>
                              </td>
                              <td class="text-nowrap">
                                <div>
                                  <i class="mdi mdi-map-marker text-danger me-1"></i>
                                  <div>{{ ad.subCounty }}</div>
                                  <small class="text-muted">{{ ad.ward }}</small>
                                  <small class="text-muted d-block">{{ ad.specificLocation }}</small>
                                </div>
                              </td>
                              <td class="text-nowrap">
                                <div>
                                  <div class="fw-bold">{{ ad.client.name }}</div>
                                  <small class="text-muted"><i class="mdi mdi-phone me-1"></i>{{ ad.client.phone }}</small>
                                  <small class="text-muted d-block"><i class="mdi mdi-email me-1"></i>{{ ad.client.email }}</small>
                                  <small class="text-muted d-block">{{ ad.client.businessType }}</small>
                                </div>
                              </td>
                              <td class="text-nowrap">
                                <div>
                                  <div class="fw-semibold">{{ formatPrice(ad.totalAmount) }}</div>
                                  <small class="text-muted">{{ ad.paymentPeriod }} months</small>
                                  <small class="text-muted d-block">
                                    <span :class="ad.paymentStatus === 'PAID' ? 'text-success' : 'text-danger'">
                                      <i :class="ad.paymentStatus === 'PAID' ? 'mdi mdi-check-circle' : 'mdi mdi-alert-circle'" class="me-1"></i>
                                      {{ ad.paymentStatus }}
                                    </span>
                                  </small>
                                </div>
                              </td>
                              <td class="text-nowrap">
                                <span class="badge" :class="getStatusClass(ad.status)">
                                  {{ ad.status }}
                                </span>
                                <small class="text-muted d-block">{{ getDaysRemaining(ad.endDate) }}</small>
                              </td>
                              <td class="text-nowrap">
                                <div class="d-flex gap-1">
                                  <button @click="viewAdvertDetails(ad)"
                                          class="btn btn-primary btn-sm"
                                          data-bs-toggle="modal"
                                          data-bs-target="#advertDetailsModal">
                                    <i class="mdi mdi-eye"></i>
                                  </button>
                                  <button @click="openAdvertModal(ad)"
                                          class="btn btn-outline-secondary btn-sm">
                                    <i class="mdi mdi-pencil"></i>
                                  </button>
                                  <div class="dropdown">
                                    <button class="btn btn-outline-secondary btn-sm dropdown-toggle"
                                            data-bs-toggle="dropdown">
                                      <i class="bx bx-dots-vertical"></i>
                                    </button>
                                    <ul class="dropdown-menu">
                                      <li><a class="dropdown-item" @click="generateInvoiceFor(ad)">
                                        <i class="mdi mdi-receipt me-2"></i>Generate Invoice</a></li>
                                      <li><a class="dropdown-item" @click="sendNotification(ad)">
                                        <i class="mdi mdi-email-send me-2"></i>Send Notification</a></li>
                                      <li v-if="ad.status === 'PENDING'"><a class="dropdown-item text-success" @click="approveAd(ad)">
                                        <i class="mdi mdi-check me-2"></i>Approve</a></li>
                                      <li v-if="ad.status === 'ACTIVE'"><a class="dropdown-item text-warning" @click="suspendAd(ad)">
                                        <i class="mdi mdi-pause me-2"></i>Suspend</a></li>
                                      <li><a class="dropdown-item" @click="generatePenaltyFor(ad)">
                                        <i class="mdi mdi-alert me-2"></i>Generate Penalty</a></li>
                                      <li><hr class="dropdown-divider"></li>
                                      <li><a class="dropdown-item text-danger" @click="terminateAd(ad)">
                                        <i class="mdi mdi-delete me-2"></i>Terminate</a></li>
                                    </ul>
                                  </div>
                                </div>
                              </td>
                            </tr>
                            </tbody>
                          </table>

                          <!-- Loading State -->
                          <div v-if="loading" class="text-center p-5">
                            <div class="spinner-border text-info mb-3" role="status">
                              <span class="visually-hidden">Loading...</span>
                            </div>
                            <h4>Loading Advertisements</h4>
                            <p>We are fetching the advertisement data for you. Please wait...</p>
                          </div>

                          <!-- No Results -->
                          <div v-if="filteredAdvertisements.length < 1 && !loading" class="text-center p-5">
                            <img :src="'./assets/images/no-results.png'" class="img-fluid mb-4" alt="No results" style="max-width: 200px;">
                            <h4>No Advertisements Found</h4>
                            <p>Sorry, we could not find any advertisements that match your search or filter criteria.</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Other tabs would have similar content filtered by type -->
                  </div>

                  <!-- Pagination -->
                  <div class="card-footer bg-white">
                    <nav class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <span class="me-3">Rows Per Page</span>
                        <select class="form-select w-auto" v-model="pageSize">
                          <option value="10">10 Rows</option>
                          <option value="25">25 Rows</option>
                          <option value="50">50 Rows</option>
                          <option value="100">100 Rows</option>
                        </select>
                      </div>

                      <div class="d-flex align-items-center">
                        <span class="me-3">
                          Showing {{ (currentPage - 1) * pageSize + 1 }} to
                          {{ Math.min(currentPage * pageSize, filteredAdvertisements.length) }}
                          of {{ filteredAdvertisements.length }} entries
                        </span>
                      </div>

                      <ul class="pagination mb-0">
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                          <button class="page-link" @click="prevPage" :disabled="currentPage === 1">Previous</button>
                        </li>
                        <li v-for="page in visiblePages" :key="page"
                            class="page-item" :class="{ active: currentPage === page }">
                          <span v-if="page === '...'" class="page-link">{{ page }}</span>
                          <button v-else class="page-link" @click="goToPage(page)">{{ page }}</button>
                        </li>
                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                          <button class="page-link" @click="nextPage" :disabled="currentPage === totalPages">Next</button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Advertisement Details Modal -->
        <div class="modal fade" id="advertDetailsModal" tabindex="-1" aria-hidden="true">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Advertisement Details</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
              </div>
              <div class="modal-body" v-if="selectedAd && selectedAd.name">
                <div class="row">
                  <div class="col-md-6">
                    <div class="card">
                      <div class="card-header">
                        <h6 class="mb-0">Advertisement Preview</h6>
                      </div>
                      <div class="card-body text-center">
                        <img :src="selectedAd.image || selectedAd.imagePreview || 'https://via.placeholder.com/400x300'"
                             class="img-fluid rounded mb-3"
                             :alt="selectedAd.name"
                             style="max-height: 300px;">
                        <h5>{{ selectedAd.name }}</h5>
                        <p class="text-muted">{{ selectedAd.description }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="card">
                      <div class="card-header">
                        <h6 class="mb-0">Advertisement Information</h6>
                      </div>
                      <div class="card-body">
                        <div class="row mb-3">
                          <div class="col-sm-4"><strong>Advertisement ID:</strong></div>
                          <div class="col-sm-8">{{ selectedAd.advertisementId }}</div>
                        </div>
                        <div class="row mb-3">
                          <div class="col-sm-4"><strong>Type:</strong></div>
                          <div class="col-sm-8">
                            <span class="badge" :class="getTypeClass(selectedAd.type)">{{ formatAdType(selectedAd.type) }}</span>
                          </div>
                        </div>
                        <div class="row mb-3">
                          <div class="col-sm-4"><strong>Size:</strong></div>
                          <div class="col-sm-8">{{ selectedAd.size }}</div>
                        </div>
                        <div class="row mb-3">
                          <div class="col-sm-4"><strong>Location:</strong></div>
                          <div class="col-sm-8">
                            {{ selectedAd.specificLocation }}, {{ selectedAd.ward }}, {{ selectedAd.subCounty }}
                          </div>
                        </div>
                        <div class="row mb-3">
                          <div class="col-sm-4"><strong>Duration:</strong></div>
                          <div class="col-sm-8">{{ selectedAd.startDate }} - {{ selectedAd.endDate }}</div>
                        </div>
                        <div class="row mb-3">
                          <div class="col-sm-4"><strong>Status:</strong></div>
                          <div class="col-sm-8">
                            <span class="badge" :class="getStatusClass(selectedAd.status)">{{ selectedAd.status }}</span>
                            <small class="text-muted ms-2">{{ getDaysRemaining(selectedAd.endDate) }}</small>
                          </div>
                        </div>
                        <div class="row mb-3">
                          <div class="col-sm-4"><strong>Total Amount:</strong></div>
                          <div class="col-sm-8">{{ formatPrice(selectedAd.totalAmount) }}</div>
                        </div>
                        <div class="row mb-3">
                          <div class="col-sm-4"><strong>Payment Status:</strong></div>
                          <div class="col-sm-8">
                            <span :class="selectedAd.paymentStatus === 'PAID' ? 'text-success' : 'text-danger'">
                              <i :class="selectedAd.paymentStatus === 'PAID' ? 'mdi mdi-check-circle' : 'mdi mdi-alert-circle'" class="me-1"></i>
                              {{ selectedAd.paymentStatus }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="card mt-3">
                      <div class="card-header">
                        <h6 class="mb-0">Client Information</h6>
                      </div>
                      <div class="card-body">
                        <div class="row mb-3">
                          <div class="col-sm-4"><strong>Client Name:</strong></div>
                          <div class="col-sm-8">{{ selectedAd.client.name }}</div>
                        </div>
                        <div class="row mb-3">
                          <div class="col-sm-4"><strong>Phone:</strong></div>
                          <div class="col-sm-8">{{ selectedAd.client.phone }}</div>
                        </div>
                        <div class="row mb-3">
                          <div class="col-sm-4"><strong>Email:</strong></div>
                          <div class="col-sm-8">{{ selectedAd.client.email }}</div>
                        </div>
                        <div class="row mb-3">
                          <div class="col-sm-4"><strong>Business Type:</strong></div>
                          <div class="col-sm-8">{{ selectedAd.client.businessType }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer" v-if="selectedAd && selectedAd.name">
                <button type="button" class="btn btn-success" @click="generateInvoiceFor(selectedAd)">
                  <i class="mdi mdi-receipt me-1"></i>Generate Invoice
                </button>
                <button type="button" class="btn btn-primary" @click="sendNotification(selectedAd)">
                  <i class="mdi mdi-email-send me-1"></i>Send Notification
                </button>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Register Advertisement Modal -->
        <RegisterAdvertisementModal
            :advertisement="selectedAdvertisement"
            @advertisement-saved="handleAdvertisementSaved"
            @show-message="showMessage"
        />

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6"></div>
              <div class="col-sm-6">
                <div class="text-sm-end">Developed by  County</div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import { authUrl, biller, execute, executeDownload, getRight } from "@/api";
import NavigationBar from "@/components/Navigation";
import RegisterAdvertisementModal from "@/components/adverts/modal/RegisterAdvertisementModal";
import router from "@/router";
import moment from "moment";

export default {
  name: "OutdoorAdvertisementManagement",
  components: {
    NavigationBar,
    RegisterAdvertisementModal
  },
  data() {
    return {
      loading: false,
      search: '',
      currentPage: 1,
      pageSize: 10,
      viewMode: 'table', // 'table', 'map'
      map: null,
      markers: [],
      showAllMarkers: true,
      selectedAdvertisement: null,

      // Filters
      filters: {
        type: '',
        status: '',
        subCounty: '',
        ward: ''
      },

      // Filter options ( County)
      subCounties: [
        'Imenti North', 'Imenti South', 'Imenti Central',
        'Tigania East', 'Tigania West',
        'Igembe North', 'Igembe South', 'Igembe Central',
        'Buuri'
      ],
      wards: [
        // Imenti Central
        'Ntima East', 'Ntima West', 'Nyaki East', 'Nyaki West', 'Abothuguchi Central', 'Abothuguchi West',
        // Imenti North
        'Municipality', 'Mikinduri', 'Kiirua/Naari', 'Ruiri/Rwarera',
        // Buuri
        'Timau', 'Kibirichia', 'Rugubu', 'Thingithu',
        // Tigania
        'Muthara', 'Karama', 'Athwana', 'Thangatha',
        // Igembe
        'Antuambui', 'Amwathi', 'Akachiu', 'Antubetwe Kiongo', 'Njia'
      ],

      // Statistics
      statistics: {
        totalAds: 0,
        activeAds: 0,
        expiredAds: 0,
        pendingAds: 0,
        monthlyRevenue: 0,
        penalties: 520000
      },

      // Advertisements data ( County)
      advertisements: [
        {
          id: 1,
          advertisementId: "MRU-AD-001",
          name: "Safaricom 5G Launch - ",
          description: "Large billboard showcasing Safaricom's 5G rollout across  town.",
          type: "BILLBOARD",
          size: "48 x 12 feet",
          subCounty: "Imenti North",
          ward: "Municipality",
          specificLocation: "–Nanyuki Road, near Makutano Junction",
          gpsCoordinates: "0.0470, 37.6550",
          image: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=400&h=300&fit=crop",
          startDate: "2024-12-01",
          endDate: "2025-06-01",
          paymentPeriod: 6,
          totalAmount: 195000,
          paymentStatus: "PAID",
          status: "ACTIVE",
          lastUpdated: "2025-01-15",
          registrationDate: "2024-11-15",
          paymentMethod: "BANK_TRANSFER",
          client: {
            name: "Safaricom PLC",
            phone: "+254722000000",
            email: "marketing@safaricom.co.ke",
            businessType: "Telecommunications",
            contactPerson: "Jane Mwangi",
            address: "Safaricom House, Nairobi"
          },
          charges: {
            baseRate: 26000,
            locationMultiplier: 1.6,
            sizeMultiplier: 2.0,
            durationDiscount: 0.1
          }
        },
        {
          id: 2,
          advertisementId: "MRU-AD-002",
          name: "Equity Bank Digital Services Signage",
          description: "Illuminated signage for Equity Bank at  town branch.",
          type: "SIGNAGE",
          size: "20 x 8 feet",
          subCounty: "Imenti Central",
          ward: "Ntima East",
          specificLocation: " CBD, Tom Mboya Street",
          gpsCoordinates: "0.0485, 37.6525",
          image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=400&h=300&fit=crop",
          startDate: "2025-01-01",
          endDate: "2025-12-31",
          paymentPeriod: 12,
          totalAmount: 252000,
          paymentStatus: "PAID",
          status: "ACTIVE",
          lastUpdated: "2025-01-10",
          registrationDate: "2024-12-20",
          paymentMethod: "MPESA",
          client: {
            name: "Equity Bank Kenya Limited",
            phone: "+254711049000",
            email: "marketing@equitybank.co.ke",
            businessType: "Financial Services",
            contactPerson: "Peter Kiprotich",
            address: "Equity Centre, Nairobi"
          },
          charges: {
            baseRate: 15500,
            locationMultiplier: 1.3,
            sizeMultiplier: 1.2,
            durationDiscount: 0.15
          }
        },
        {
          id: 3,
          advertisementId: "MRU-AD-003",
          name: "Coca-Cola Mobile Roadshow",
          description: "Brand activation truck traversing Imenti South markets.",
          type: "MOBILE",
          size: "Vehicle Branding",
          subCounty: "Imenti South",
          ward: "Abothuguchi West",
          specificLocation: "Nkubu, Kionyo, Mitunguu circuit",
          gpsCoordinates: "-0.1110, 37.6530",
          image: "https://images.unsplash.com/photo-1594736797933-d0501ba2fe65?w=400&h=300&fit=crop",
          startDate: "2024-11-15",
          endDate: "2025-02-15",
          paymentPeriod: 3,
          totalAmount: 82000,
          paymentStatus: "PAID",
          status: "ACTIVE",
          lastUpdated: "2025-01-12",
          registrationDate: "2024-11-01",
          paymentMethod: "CHEQUE",
          client: {
            name: "The Coca-Cola Company (Kenya)",
            phone: "+254733000111",
            email: "kenya@coca-cola.com",
            businessType: "Beverage Manufacturing",
            contactPerson: "Mary Njeri",
            address: "Coca-Cola Plaza, Nairobi"
          },
          charges: {
            baseRate: 22000,
            locationMultiplier: 1.0,
            sizeMultiplier: 1.5,
            durationDiscount: 0.0
          }
        },
        {
          id: 4,
          advertisementId: "MRU-AD-004",
          name: "KCB SME Loans Poster Drive",
          description: "Poster campaign targeting SME traders in Tigania East.",
          type: "POSTER",
          size: "A2 Size (60 posters)",
          subCounty: "Tigania East",
          ward: "Muthara",
          specificLocation: "Muthara Market notice boards and kiosks",
          gpsCoordinates: "0.2850, 37.9900",
          image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=400&h=300&fit=crop",
          startDate: "2025-01-10",
          endDate: "2025-04-10",
          paymentPeriod: 3,
          totalAmount: 18000,
          paymentStatus: "PENDING",
          status: "PENDING",
          lastUpdated: "2025-01-14",
          registrationDate: "2025-01-05",
          paymentMethod: "CASH",
          client: {
            name: "Kenya Commercial Bank",
            phone: "+254711087000",
            email: "marketing@kcbgroup.com",
            businessType: "Financial Services",
            contactPerson: "James Mutua",
            address: "KCB Towers, Nairobi"
          },
          charges: {
            baseRate: 3200,
            locationMultiplier: 1.0,
            sizeMultiplier: 0.8,
            durationDiscount: 0.0
          }
        },
        {
          id: 5,
          advertisementId: "MRU-AD-005",
          name: "Tusker Billboard - Past Campaign",
          description: "Billboard along the –Embu highway; campaign ended.",
          type: "BILLBOARD",
          size: "40 x 10 feet",
          subCounty: "Imenti South",
          ward: "Abothuguchi Central",
          specificLocation: "Along –Embu Highway, near Nkubu",
          gpsCoordinates: "-0.1130, 37.6780",
          image: "https://images.unsplash.com/photo-1608270586620-248524c67de9?w=400&h=300&fit=crop",
          startDate: "2024-06-01",
          endDate: "2024-12-01",
          paymentPeriod: 6,
          totalAmount: 158000,
          paymentStatus: "PAID",
          status: "EXPIRED",
          lastUpdated: "2024-12-01",
          registrationDate: "2024-05-15",
          paymentMethod: "BANK_TRANSFER",
          client: {
            name: "East African Breweries Limited",
            phone: "+254722200300",
            email: "marketing@eabl.co.ke",
            businessType: "Beverage Manufacturing",
            contactPerson: "Grace Wanjiku",
            address: "EABL Tower, Nairobi"
          },
          charges: {
            baseRate: 23000,
            locationMultiplier: 1.2,
            sizeMultiplier: 1.8,
            durationDiscount: 0.05
          }
        },
        {
          id: 6,
          advertisementId: "MRU-AD-006",
          name: "M-Pesa Agent Recruitment Banner",
          description: "Banner calling for new M-Pesa agents in Timau town.",
          type: "BANNER",
          size: "30 x 6 feet",
          subCounty: "Buuri",
          ward: "Timau",
          specificLocation: "Timau Market main entrance",
          gpsCoordinates: "0.0730, 37.2470",
          image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=400&h=300&fit=crop",
          startDate: "2025-01-01",
          endDate: "2025-03-31",
          paymentPeriod: 3,
          totalAmount: 47000,
          paymentStatus: "PAID",
          status: "ACTIVE",
          lastUpdated: "2025-01-08",
          registrationDate: "2024-12-15",
          paymentMethod: "MPESA",
          client: {
            name: "Safaricom PLC",
            phone: "+254722000000",
            email: "mpesa@safaricom.co.ke",
            businessType: "Telecommunications",
            contactPerson: "David Kimani",
            address: "Safaricom House, Nairobi"
          },
          charges: {
            baseRate: 12500,
            locationMultiplier: 1.0,
            sizeMultiplier: 1.3,
            durationDiscount: 0.0
          }
        },
        {
          id: 7,
          advertisementId: "MRU-AD-007",
          name: "Unga Wheat Flour Roadshow",
          description: "Mobile roadshow across Igembe South markets.",
          type: "MOBILE",
          size: "Roadshow Setup",
          subCounty: "Igembe South",
          ward: "Njia",
          specificLocation: "Maua, Kiengu and surrounding markets",
          gpsCoordinates: "0.2330, 37.9400",
          image: "https://images.unsplash.com/photo-1586985289688-ca3cf47d3e6e?w=400&h=300&fit=crop",
          startDate: "2024-12-01",
          endDate: "2025-01-31",
          paymentPeriod: 2,
          totalAmount: 82000,
          paymentStatus: "PAID",
          status: "ACTIVE",
          lastUpdated: "2025-01-11",
          registrationDate: "2024-11-20",
          paymentMethod: "CHEQUE",
          client: {
            name: "Unga Limited",
            phone: "+254711500600",
            email: "marketing@unga.co.ke",
            businessType: "Food Manufacturing",
            contactPerson: "Susan Mutindi",
            address: "Unga House, Nairobi"
          },
          charges: {
            baseRate: 25000,
            locationMultiplier: 0.9,
            sizeMultiplier: 2.0,
            durationDiscount: 0.0
          }
        },
        {
          id: 8,
          advertisementId: "MRU-AD-008",
          name: "NHIF Services Signage",
          description: "Signage encouraging NHIF registration in Igembe North.",
          type: "SIGNAGE",
          size: "15 x 10 feet",
          subCounty: "Igembe North",
          ward: "Antubetwe Kiongo",
          specificLocation: "Maua Level 4 Hospital compound",
          gpsCoordinates: "0.2335, 37.9405",
          image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?w=400&h=300&fit=crop",
          startDate: "2024-10-01",
          endDate: "2025-09-30",
          paymentPeriod: 12,
          totalAmount: 186000,
          paymentStatus: "PAID",
          status: "ACTIVE",
          lastUpdated: "2025-01-09",
          registrationDate: "2024-09-15",
          paymentMethod: "BANK_TRANSFER",
          client: {
            name: "National Hospital Insurance Fund",
            phone: "+254711600700",
            email: "info@nhif.or.ke",
            businessType: "Healthcare Insurance",
            contactPerson: "Dr. Francis Wafula",
            address: "NHIF Building, Nairobi"
          },
          charges: {
            baseRate: 12000,
            locationMultiplier: 0.95,
            sizeMultiplier: 1.1,
            durationDiscount: 0.20
          }
        }
      ],

      filteredAdvertisements: [],
      selectedAd: null,

      // Alerts
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: ''
    }
  },
  computed: {
    paginatedAdvertisements() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.filteredAdvertisements.slice(start, end);
    },

    totalPages() {
      return Math.ceil(this.filteredAdvertisements.length / this.pageSize);
    },

    visiblePages() {
      const maxVisible = 5;
      const pages = [];
      const total = this.totalPages;
      const current = this.currentPage;

      if (total <= maxVisible) {
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
      } else {
        if (current <= 3) {
          for (let i = 1; i <= 4; i++) pages.push(i);
          pages.push('...');
          pages.push(total);
        } else if (current >= total - 2) {
          pages.push(1);
          pages.push('...');
          for (let i = total - 3; i <= total; i++) pages.push(i);
        } else {
          pages.push(1);
          pages.push('...');
          for (let i = current - 1; i <= current + 1; i++) pages.push(i);
          pages.push('...');
          pages.push(total);
        }
      }

      return pages;
    }
  },
  watch: {
    search() {
      this.filterAdvertisements();
    },
    pageSize() {
      this.currentPage = 1;
    },
    viewMode(newMode) {
      if (newMode === 'map') {
        this.$nextTick(() => {
          this.initializeMap();
        });
      }
    }
  },
  mounted() {
    this.filteredAdvertisements = [...this.advertisements];
    this.updateStatistics();
    this.menuAccess();
  },
  methods: {
    getRight,

    formatPrice(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 0
      }).format(value);
    },

    formatNumber(value) {
      return new Intl.NumberFormat('en-US').format(value);
    },

    formatAdType(type) {
      const typeMap = {
        'BILLBOARD': 'Billboard',
        'SIGNAGE': 'Signage',
        'MOBILE': 'Mobile Advertisement',
        'POSTER': 'Poster/Flyer',
        'BANNER': 'Banner'
      };
      return typeMap[type] || type;
    },

    getTypeClass(type) {
      switch (type) {
        case 'BILLBOARD':
          return 'bg-primary';
        case 'SIGNAGE':
          return 'bg-success';
        case 'MOBILE':
          return 'bg-warning';
        case 'POSTER':
          return 'bg-info';
        case 'BANNER':
          return 'bg-secondary';
        default:
          return 'bg-secondary';
      }
    },

    getStatusClass(status) {
      switch (status) {
        case 'ACTIVE':
          return 'bg-success';
        case 'EXPIRED':
          return 'bg-danger';
        case 'PENDING':
          return 'bg-warning';
        case 'SUSPENDED':
          return 'bg-secondary';
        default:
          return 'bg-secondary';
      }
    },

    getAdCount(type) {
      return this.advertisements.filter(ad => ad.type === type).length;
    },

    getDaysRemaining(endDate) {
      const end = moment(endDate);
      const now = moment();
      const days = end.diff(now, 'days');

      if (days < 0) {
        return `Expired ${Math.abs(days)} days ago`;
      } else if (days === 0) {
        return 'Expires today';
      } else {
        return `${days} days remaining`;
      }
    },

    goTo(route) {
      router.push(route);
    },

    toggleViewMode() {
      this.viewMode = this.viewMode === 'table' ? 'map' : 'table';
    },

    initializeMap() {
      if (this.map) {
        this.map.remove();
      }

      // Initialize map centered on  County
      this.map = L.map(this.$refs.mapContainer).setView([0.0470, 37.6550], 11);

      // Add OpenStreetMap tiles
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(this.map);

      // Add markers for all advertisements
      this.addMarkersToMap();
    },

    addMarkersToMap() {
      // Clear existing markers
      this.markers.forEach(marker => {
        this.map.removeLayer(marker);
      });
      this.markers = [];

      // Add markers for each advertisement
      this.filteredAdvertisements.forEach(ad => {
        if (ad.gpsCoordinates) {
          const [lat, lng] = ad.gpsCoordinates.split(',').map(coord => parseFloat(coord.trim()));

          // Create custom icon based on status
          const iconColor = this.getMarkerColor(ad.status);
          const icon = L.divIcon({
            className: `custom-marker-icon ${iconColor}`,
            html: `<div class="marker-pin ${iconColor}">
                     <i class="mdi ${this.getAdTypeIcon(ad.type)}"></i>
                   </div>`,
            iconSize: [30, 40],
            iconAnchor: [15, 40],
            popupAnchor: [0, -40]
          });

          // Create marker
          const marker = L.marker([lat, lng], { icon }).addTo(this.map);

          // Create popup content
          const popupContent = `
            <div class="map-popup">
              <div class="popup-header">
                <img src="${ad.image || ad.imagePreview || 'https://via.placeholder.com/250x150'}" alt="${ad.name}" style="width: 100%; height: 120px; object-fit: cover; border-radius: 4px;">
                <span class="badge ${this.getStatusClass(ad.status)} position-absolute" style="top: 5px; right: 5px;">${ad.status}</span>
              </div>
              <div class="popup-content p-2">
                <h6 class="mb-1">${ad.name}</h6>
                <p class="text-muted mb-2 small">${ad.description}</p>
                <div class="mb-2">
                  <small><strong>Type:</strong> ${this.formatAdType(ad.type)}</small><br>
                  <small><strong>Size:</strong> ${ad.size}</small><br>
                  <small><strong>Location:</strong> ${ad.specificLocation}</small><br>
                  <small><strong>Client:</strong> ${ad.client.name}</small><br>
                  <small><strong>Duration:</strong> ${ad.startDate} - ${ad.endDate}</small><br>
                  <small><strong>Amount:</strong> ${this.formatPrice(ad.totalAmount)}</small>
                </div>
                <div class="d-flex gap-1">
                  <button onclick="window.viewAdFromMap('${ad.id}')" class="btn btn-primary btn-sm">
                    <i class="mdi mdi-eye"></i> View Details
                  </button>
                  <button onclick="window.generateInvoiceFromMap('${ad.id}')" class="btn btn-success btn-sm">
                    <i class="mdi mdi-receipt"></i> Invoice
                  </button>
                </div>
              </div>
            </div>
          `;

          marker.bindPopup(popupContent, { maxWidth: 300 });
          this.markers.push(marker);
        }
      });

      // Add global functions for popup buttons
      window.viewAdFromMap = (adId) => {
        const ad = this.advertisements.find(a => a.id == adId);
        if (ad) {
          this.viewAdvertDetails(ad);
          // Trigger modal
          const modal = new bootstrap.Modal(document.getElementById('advertDetailsModal'));
          modal.show();
        }
      };

      window.generateInvoiceFromMap = (adId) => {
        const ad = this.advertisements.find(a => a.id == adId);
        if (ad) {
          this.generateInvoiceFor(ad);
        }
      };
    },

    getMarkerColor(status) {
      switch (status) {
        case 'ACTIVE':
          return 'marker-green';
        case 'EXPIRED':
          return 'marker-red';
        case 'PENDING':
          return 'marker-yellow';
        case 'SUSPENDED':
          return 'marker-gray';
        default:
          return 'marker-blue';
      }
    },

    getAdTypeIcon(type) {
      switch (type) {
        case 'BILLBOARD':
          return 'mdi-billboard';
        case 'SIGNAGE':
          return 'mdi-sign-caution';
        case 'MOBILE':
          return 'mdi-truck';
        case 'POSTER':
          return 'mdi-file-image';
        case 'BANNER':
          return 'mdi-flag';
        default:
          return 'mdi-advertisement';
      }
    },

    centerMap() {
      if (this.map) {
        this.map.setView([0.0470, 37.6550], 11);
      }
    },

    toggleMarkers() {
      this.showAllMarkers = !this.showAllMarkers;
      if (this.showAllMarkers) {
        this.markers.forEach(marker => {
          this.map.addLayer(marker);
        });
      } else {
        this.markers.forEach(marker => {
          this.map.removeLayer(marker);
        });
      }
    },

    filterAdvertisements() {
      let filtered = [...this.advertisements];

      // Filter by search
      if (this.search.trim()) {
        const searchTerm = this.search.toLowerCase();
        filtered = filtered.filter(ad =>
            ad.advertisementId.toLowerCase().includes(searchTerm) ||
            ad.name.toLowerCase().includes(searchTerm) ||
            ad.description.toLowerCase().includes(searchTerm) ||
            ad.specificLocation.toLowerCase().includes(searchTerm) ||
            ad.client.name.toLowerCase().includes(searchTerm)
        );
      }

      // Filter by type
      if (this.filters.type) {
        filtered = filtered.filter(ad => ad.type === this.filters.type);
      }

      // Filter by status
      if (this.filters.status) {
        filtered = filtered.filter(ad => ad.status === this.filters.status);
      }

      // Filter by sub county
      if (this.filters.subCounty) {
        filtered = filtered.filter(ad => ad.subCounty === this.filters.subCounty);
      }

      // Filter by ward
      if (this.filters.ward) {
        filtered = filtered.filter(ad => ad.ward === this.filters.ward);
      }

      this.filteredAdvertisements = filtered;
      this.currentPage = 1;

      // Update map markers if map is visible
      if (this.viewMode === 'map' && this.map) {
        this.addMarkersToMap();
      }
    },

    viewAdvertDetails(ad) {
      this.selectedAd = { ...ad }; // Create a copy to avoid reactivity issues
    },

    openAdvertModal(ad = null) {
      this.selectedAdvertisement = ad;

      // Show the modal using Bootstrap
      const modal = new bootstrap.Modal(document.getElementById('registerAdvertModal'));
      modal.show();
    },

    handleAdvertisementSaved(advertisementData) {
      if (this.selectedAdvertisement) {
        // Update existing advertisement
        const index = this.advertisements.findIndex(a => a.id === this.selectedAdvertisement.id);
        if (index !== -1) {
          this.advertisements[index] = {
            ...this.advertisements[index],
            ...advertisementData,
            lastUpdated: moment().format('YYYY-MM-DD')
          };
        }
      } else {
        // Add new advertisement
        const newAd = {
          id: this.advertisements.length + 1,
          ...advertisementData,
          registrationDate: moment().format('YYYY-MM-DD'),
          lastUpdated: moment().format('YYYY-MM-DD')
        };
        this.advertisements.push(newAd);
      }

      // Update statistics
      this.updateStatistics();

      // Refresh the filtered list
      this.filterAdvertisements();

      // Clear selection
      this.selectedAdvertisement = null;
    },

    showMessage({ type, message }) {
      this.message = message;
      if (type === 'success') {
        this.alert.success = true;
      } else if (type === 'error') {
        this.alert.failed = true;
      } else {
        this.alert.info = true;
      }

      setTimeout(() => {
        this.alert.success = false;
        this.alert.failed = false;
        this.alert.info = false;
        this.message = '';
      }, 5000);
    },

    updateStatistics() {
      this.statistics.totalAds = this.advertisements.length;
      this.statistics.activeAds = this.advertisements.filter(ad => ad.status === 'ACTIVE').length;
      this.statistics.expiredAds = this.advertisements.filter(ad => ad.status === 'EXPIRED').length;
      this.statistics.pendingAds = this.advertisements.filter(ad => ad.status === 'PENDING').length;

      // Calculate monthly revenue (simplified)
      const currentMonth = moment().format('YYYY-MM');
      this.statistics.monthlyRevenue = this.advertisements
          .filter(ad => {
            const adMonth = moment(ad.startDate).format('YYYY-MM');
            return adMonth === currentMonth && ad.paymentStatus === 'PAID';
          })
          .reduce((sum, ad) => sum + (ad.totalAmount / ad.paymentPeriod), 0);
    },

    generateInvoiceFor(ad) {
      this.message = `Generating invoice for ${ad.name}...`;
      this.alert.info = true;

      // Simulate
      setTimeout(() => {
        this.alert.info = false;
        this.message = `Invoice generated successfully for ${ad.advertisementId}`;
        this.alert.success = true;

        setTimeout(() => {
          this.alert.success = false;
          this.message = '';
        }, 3000);
      }, 2000);
    },

    sendNotification(ad) {
      this.message = `Sending notification to ${ad.client.name}...`;
      this.alert.info = true;

      setTimeout(() => {
        this.alert.info = false;
        this.message = `Notification sent to ${ad.client.email}`;
        this.alert.success = true;

        setTimeout(() => {
          this.alert.success = false;
          this.message = '';
        }, 3000);
      }, 2000);
    },

    approveAd(ad) {
      ad.status = 'ACTIVE';
      ad.lastUpdated = moment().format('YYYY-MM-DD');

      this.message = `Advertisement ${ad.advertisementId} has been approved`;
      this.alert.success = true;
      this.updateStatistics();
      this.filterAdvertisements();

      setTimeout(() => {
        this.alert.success = false;
        this.message = '';
      }, 3000);
    },

    suspendAd(ad) {
      if (confirm(`Are you sure you want to suspend ${ad.advertisementId}?`)) {
        ad.status = 'SUSPENDED';
        ad.lastUpdated = moment().format('YYYY-MM-DD');

        this.message = `Advertisement ${ad.advertisementId} has been suspended`;
        this.alert.info = true;
        this.updateStatistics();
        this.filterAdvertisements();

        setTimeout(() => {
          this.alert.info = false;
          this.message = '';
        }, 3000);
      }
    },

    generatePenaltyFor(ad) {
      this.message = `Generating penalty for ${ad.advertisementId}...`;
      this.alert.info = true;

      setTimeout(() => {
        this.alert.info = false;
        this.message = `Penalty notice generated for ${ad.advertisementId}`;
        this.alert.success = true;

        setTimeout(() => {
          this.alert.success = false;
          this.message = '';
        }, 3000);
      }, 2000);
    },

    terminateAd(ad) {
      if (confirm(`Are you sure you want to terminate ${ad.advertisementId}? This action cannot be undone.`)) {
        ad.status = 'EXPIRED';
        ad.lastUpdated = moment().format('YYYY-MM-DD');

        this.message = `Advertisement ${ad.advertisementId} has been terminated`;
        this.alert.info = true;
        this.updateStatistics();
        this.filterAdvertisements();

        setTimeout(() => {
          this.alert.info = false;
          this.message = '';
        }, 3000);
      }
    },

    openBulkUpload() {
      this.message = "Bulk upload functionality will open here";
      this.alert.info = true;

      setTimeout(() => {
        this.alert.info = false;
        this.message = '';
      }, 3000);
    },

    generateInvoices() {
      this.message = "Generating invoices for all pending advertisements...";
      this.alert.info = true;

      const pendingCount = this.advertisements.filter(ad => ad.paymentStatus === 'PENDING').length;

      setTimeout(() => {
        this.alert.info = false;
        this.message = `Generated ${pendingCount} invoices successfully`;
        this.alert.success = true;

        setTimeout(() => {
          this.alert.success = false;
          this.message = '';
        }, 3000);
      }, 2000);
    },

    generatePenalties() {
      this.message = "Generating penalties for expired advertisements...";
      this.alert.info = true;

      const expiredCount = this.advertisements.filter(ad => ad.status === 'EXPIRED').length;

      setTimeout(() => {
        this.alert.info = false;
        this.message = `Generated ${expiredCount} penalty notices`;
        this.alert.success = true;

        setTimeout(() => {
          this.alert.success = false;
          this.message = '';
        }, 3000);
      }, 2000);
    },

    generateReports() {
      this.message = "Generating comprehensive advertisement reports...";
      this.alert.info = true;

      setTimeout(() => {
        this.alert.info = false;
        this.message = "Report generated successfully. Downloading...";
        this.alert.success = true;

        setTimeout(() => {
          this.alert.success = false;
          this.message = '';
        }, 3000);
      }, 2000);
    },

    // Pagination methods
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
      }
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Outdoor Advertisement Management");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, biller).catch(e => {
        console.error("Menu access error:", e.message);
      });
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.legend-item {
  display: inline-block;
  margin-right: 1rem;
}

/* Map Styles */
.custom-marker-icon {
  background: transparent;
  border: none;
}

.marker-pin {
  width: 30px;
  height: 30px;
  border-radius: 50% 50% 50% 0%;
  position: relative;
  transform: rotate(-45deg);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.marker-pin i {
  transform: rotate(45deg);
  color: white;
  font-size: 14px;
}

.marker-green { background-color: #28a745; }
.marker-red { background-color: #dc3545; }
.marker-yellow { background-color: #ffc107; }
.marker-gray { background-color: #6c757d; }
.marker-blue { background-color: #007bff; }

.marker-legend {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
}

.marker-legend.active { background-color: #28a745; }
.marker-legend.expired { background-color: #dc3545; }
.marker-legend.pending { background-color: #ffc107; }

.map-popup {
  min-width: 250px;
}

.popup-header {
  position: relative;
}

.popup-content h6 {
  color: #333;
  font-weight: 600;
}

/* Table & UI */
.table th {
  white-space: nowrap;
  vertical-align: middle;
}

.table td {
  vertical-align: middle;
}

.form-label {
  font-weight: 600;
  font-size: 0.875rem;
}

.badge {
  font-size: 0.75rem;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}

.card-header {
  padding: 1rem;
}

.nav-tabs .nav-link {
  border-bottom: 2px solid transparent;
}

.nav-tabs .nav-link.active {
  border-bottom-color: #0d6efd;
  font-weight: 600;
}

.border {
  border-color: #dee2e6 !important;
}

.bg-light {
  background-color: #f8f9fa !important;
}

.position-relative img {
  border-radius: 0.375rem;
}

.modal-xl {
  max-width: 1200px;
}

@media (max-width: 768px) {
  .table-responsive {
    font-size: 0.875rem;
  }

  .card-body {
    padding: 0.75rem;
  }

  .btn-sm {
    padding: 0.15rem 0.3rem;
    font-size: 0.7rem;
  }
}
</style>
